import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { SwipeFile } from '../components/SwipeFile';
import { Dashboard } from '../components/Dashboard';
import { Brain } from '../components/Brain';
import { Profiles } from '../components/Profiles';
type ActiveTab = 'dashboard' | 'brain' | 'swipefile' | 'profiles' | 'settings';
export function HomePage() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('dashboard');
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard data-id="element-670" />;
      case 'brain':
        return <Brain data-id="element-671" />;
      case 'swipefile':
        return <SwipeFile data-id="element-672" />;
      case 'profiles':
        return <Profiles data-id="element-673" />;
      default:
        return <Dashboard data-id="element-674" />;
    }
  };
  return <div className="flex h-screen w-full bg-white overflow-hidden font-sans text-gray-900" data-id="element-675">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} className="hidden md:flex" data-id="element-676" />
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-677">
        {renderContent()}
      </main>
    </div>;
}